import { useModal } from "@pulse/hooks/contextHooks";
import { useTranslation } from "react-i18next";
import { ParticipantsForm } from "./Participant";
import { useCurrentSurvey } from "@pulse/hooks/surveyHooks";
import { Button } from "frontend-components";

export default function AddParticipantsButton() {
    const { openModal } = useModal();
    const { t } = useTranslation();
    const { data: survey } = useCurrentSurvey();
    return (
        <Button
            variant="fill"
            onClick={() =>
                openModal({
                    title: t("survey.inviteAndStart"),
                    children: <ParticipantsForm survey={survey} />,
                })
            }
        >
            {t("survey.inviteParticipants")}
        </Button>
    );
}
